<div class="container single-view" id="view-collection">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/collections" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'COLLECTIONS.BTN_BACK_TO_COLLECTION' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="collection-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'COLLECTION_SINGLE_VIEW.COLLECTION_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (collection.name) {
                  <span data-testid="collection-name">{{ collection.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">
            @if (allowModifyCollection) {
              <button data-testid='collection-edit-btn' class="btn primary-btn" (click)="goToEditCollection()">{{ 'COLLECTION_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }
            @if (delete) {
              <button data-testid='collection-delete-btn' class="btn red-btn" (click)="showDeleteDialog()">{{'COLLECTIONS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid='collection-details'>{{ 'COLLECTION_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">

                  <dt data-testid='collection-name-label' class="label grid-cols-1 pt-3">{{ 'COLLECTION_SINGLE_VIEW.NAME' | translate }}</dt>
                  <dd data-testid='collection-name' class="value pt-3 pb-3">{{ collection.name | defaultValue }}</dd>

                  <dt data-testid='collection-code-label' class="label grid-cols-1 pt-3">{{ 'COLLECTION_SINGLE_VIEW.CODE' | translate }}</dt>
                  <dd data-testid='collection-code' class="value pt-3 pb-3">{{ collection.code | defaultValue }}</dd>

                  <dt data-testid='collection-hasparent-label' class="label grid-cols-1 pt-3">{{ 'COLLECTION_SINGLE_VIEW.HAS_PARENT' | translate }}</dt>
                  <dd data-testid='collection-hasparent' class="value pt-3 pb-3">{{ (collection.parent ? 'BOOLEANS.YES' : 'BOOLEANS.NO') | translate }}</dd>

                  @if (collection.parent) {
                    <dt data-testid='collection-parent-collection-label' class="label grid-cols-1 pt-3">{{ 'COLLECTION_SINGLE_VIEW.PARENT_NAME' | translate }}</dt>
                    <dd class="value pt-3 pb-3">
                      @if (collection.parent.id) {
                        <a data-testid='collection-parent-collection' [routerLink]="['/collections/', collection.parent.id]" class="inline-flex items-center link">{{ collection.parent.name }}</a>
                      } @else {
                        {{ collection.parent.name | defaultValue }}
                      }
                    </dd>
                    <dt data-testid='collection-parent-code-label' class="label grid-cols-1 pt-3">{{ 'COLLECTION_SINGLE_VIEW.PARENT_CODE' | translate }}</dt>
                    <dd data-testid='collection-parent-code' class="value pt-3 pb-3">{{ collection.parent.code | defaultValue }}</dd>
                  }
                </dl>
              </div>
            </section>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete collection -->
<dialog-reason  #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_COLLECTION'" (onClose)="deleteCollection($event)"></dialog-reason>
